import { render, staticRenderFns } from "./UploadAudioWidget.vue?vue&type=template&id=6037ffe9"
import script from "./UploadAudioWidget.vue?vue&type=script&lang=js"
export * from "./UploadAudioWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports